import { React } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));

const ErrorMessage = (props) => {
  const {
    error,
  } = props;
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {!!error && (
        <Alert severity="warning">
          {error}
        </Alert>
      )}
    </div>
  );
};

export default ErrorMessage;
